import React, { Component } from "react";
import Helmet from "react-helmet";
import config from "../../data/SiteConfig";
import "./styles/games.css";
import Jumbotron from "../components/Jumbotron/Jumbotron";

class GamesPage extends Component {
  render() {
    return (
      <div className="GamesPage">
        <Helmet title={`Games | ${config.siteTitle}`} />
        <Jumbotron message="Nothing to see here." />
        <div className="GamesPage__content Container">
          <h2>News coming soon, follow us on Twitter.</h2>
        </div>
      </div>
    );
  }
}

export default GamesPage;



// WEBPACK FOOTER //
// ./src/pages/games.jsx